import styled from "styled-components"
import fontValues from "../../../assets/values/fontValues/fontValues.json"
import mediaQueries from "../../../utils/constants/shared/mediaQueries.json"

export const CarrouselTitle = styled.div `

    width: min-content;
    min-width: 400px;
    height: fit-content;
    text-align: left;
    margin: 0;
    color: ${({theme}) => theme.colors.LIGHT_TEXT};
    font-family: ${fontValues.TEXT_FONT_FAMILY};
    font-size: ${fontValues.HOME_TITLE_SIZE};
    font-weight: bolder;

    @media (max-width: ${mediaQueries.WIDTH_FOR_MOBILES}){
        width: 100%;
        min-width: 100%;
        font-size: ${fontValues.HOME_TITLE1_SIZE};
    }

`